export type PlayerNameFields = {
  username: string;
  displayName?: string | null;
  effectiveDisplayName?: string;
};

/** Label shown to other players in UI. */
export function playerLabel(user: PlayerNameFields): string {
  const eff = user.effectiveDisplayName?.trim();
  if (eff) return eff;
  const dn = user.displayName?.trim();
  if (dn) return dn;
  return user.username;
}
